<template>
  <!-- begin:: Header Mobile -->
  <div id="kt_header_mobile" class="kt-header-mobile kt-header-mobile--fixed">
    <div class="kt-header-mobile__logo">
      <router-link to="/home">
        <img alt="Logo" src="/img/logo-6-sm.png">
      </router-link>
    </div>
    <div class="kt-header-mobile__toolbar">
      <div
        class="kt-header-mobile__toolbar-toggler kt-header-mobile__toolbar-toggler--left"
        @click="left = !left"
        id="kt_aside_mobile_toggler"
      >
        <span></span>
      </div>
      <div
        class="kt-header-mobile__toolbar-toggler"
        id="kt_header_mobile_toggler"
        @click="middle = !middle"
      >
        <span></span>
      </div>
      <div
        class="kt-header-mobile__toolbar-topbar-toggler"
        id="kt_header_mobile_topbar_toggler"
        @click="right = !right"
      >
        <i class="flaticon-more"></i>
      </div>
    </div>
  </div>
  <!-- end:: Header Mobile -->
</template>

<script>
export default {
  props: ["msg"],
  data() {
    return {
      left: false,
      middle: false,
      right: false
    };
  },
  watch: {
    $route() {
      this.left = false;
      this.middle = false;
      this.right = false;
    },
    msg: function(newVal, oldVal) {
      console.log(newVal, oldVal);
      if (newVal.indexOf("kt_aside_close_btn") > -1) {
        this.left = false;
      } else if (newVal.indexOf("kt_header_menu_mobile_close_btn") > -1) {
        this.middle = false;
      }
    },
    left(newVal) {
      if (newVal) {
        this.showLeft();
      } else {
        this.hideLeft();
      }
    },
    middle(newVal) {
      if (newVal) {
        this.showMiddle();
      } else {
        this.hideMiddle();
      }
    },
    right(newVal) {
      if (newVal) {
        this.showRight();
      } else {
        this.hideRight();
      }
    }
  },
  methods: {
    showLeft() {
      const self = this;
      const body = document.querySelector("body");
      const elem = document.getElementById("kt_aside");
      const toggler = document.getElementById("kt_aside_mobile_toggler");

      body.classList.add("kt-aside--on");
      elem.classList.add("kt-aside--on");
      toggler.classList.add("kt-header-mobile__toolbar-toggler--active");
      this.overlay = document.createElement("DIV");
      elem.parentNode.insertBefore(this.overlay, elem.nextSibling);
      this.overlay.classList.add("kt-aside-overlay");
      this.overlay.addEventListener("click", function(e) {
        e.stopPropagation();
        e.preventDefault();
        self.left = false;
      });
    },
    hideLeft() {
      const self = this;
      const body = document.querySelector("body");
      const elem = document.getElementById("kt_aside");
      const toggler = document.getElementById("kt_aside_mobile_toggler");

      body.classList.remove("kt-aside--on");
      elem.classList.remove("kt-aside--on");
      toggler.classList.remove("kt-header-mobile__toolbar-toggler--active");
      if (this.overlay && this.overlay.parentNode) {
        this.overlay.parentNode.removeChild(this.overlay);
      }
    },
    showMiddle() {
      const self = this;
      const body = document.querySelector("body");
      const elem = document.getElementById("kt_header_menu_wrapper");
      const toggler = document.getElementById("kt_header_mobile_toggler");

      body.classList.add("kt-header-menu-wrapper--on");
      elem.classList.add("kt-header-menu-wrapper--on");
      toggler.classList.add("kt-header-mobile__toolbar-toggler--active");
      this.overlay = document.createElement("DIV");
      elem.parentNode.insertBefore(this.overlay, elem.nextSibling);
      this.overlay.classList.add("kt-header-menu-wrapper-overlay");
      this.overlay.addEventListener("click", function(e) {
        e.stopPropagation();
        e.preventDefault();
        self.middle = false;
      });
    },
    hideMiddle() {
      const self = this;
      const body = document.querySelector("body");
      const elem = document.getElementById("kt_header_menu_wrapper");
      const toggler = document.getElementById("kt_header_mobile_toggler");

      body.classList.remove("kt-header-menu-wrapper--on");
      elem.classList.remove("kt-header-menu-wrapper--on");
      toggler.classList.remove("kt-header-mobile__toolbar-toggler--active");
      if (this.overlay && this.overlay.parentNode) {
        this.overlay.parentNode.removeChild(this.overlay);
      }
    },
    showRight() {
      const body = document.querySelector("body");
      const toggler = document.getElementById(
        "kt_header_mobile_topbar_toggler"
      );

      body.classList.add("kt-header__topbar--mobile-on");
      //elem.classList.add("kt-aside--on");
      toggler.classList.add("kt-header-mobile__toolbar-topbar-toggler--active");
    },
    hideRight() {
      const body = document.querySelector("body");
      const toggler = document.getElementById(
        "kt_header_mobile_topbar_toggler"
      );

      body.classList.remove("kt-header__topbar--mobile-on");
      //elem.classList.remove("kt-aside--on");
      toggler.classList.remove(
        "kt-header-mobile__toolbar-topbar-toggler--active"
      );
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
